// Current product vocabulary for student-facing navigation.
//
// These values describe the product information architecture, not every
// implementation key in the app. Some route/session keys intentionally keep
// legacy names for compatibility.

export const CURRENT_STUDENT_SECTIONS = [
  {
    id: 'il-prof',
    label: 'Il Prof',
    drawerModeKey: 'chiedi',
    navTarget: 'prof',
    currentPath: '/prof',
    compatibilityPaths: ['/', '/chiedi'],
  },
  {
    id: 'progressi',
    label: 'Progressi',
    drawerModeKey: 'progresso',
    navTarget: 'progresso',
    currentPath: '/progresso',
    compatibilityPaths: [],
  },
  {
    id: 'simula-esame',
    label: 'Simula Esame',
    drawerModeKey: 'simula',
    navTarget: 'simula',
    currentPath: '/simula',
    compatibilityPaths: [],
  },
  {
    id: 'appendice',
    label: 'Appendice',
    drawerModeKey: 'appendice',
    navTarget: 'appendice',
    currentPath: '/appendice',
    compatibilityPaths: [],
  },
  {
    id: 'messaggi',
    label: 'Messaggi',
    drawerModeKey: 'messaggi',
    navTarget: 'messaggi',
    currentPath: '/messaggi',
    compatibilityPaths: [],
  },
] as const;

export type CurrentStudentSection = typeof CURRENT_STUDENT_SECTIONS[number];

export const LEGACY_INTERNAL_PRODUCT_KEYS = [
  {
    key: 'chiedi',
    currentMeaning: 'Il Prof chat implementation key and compatibility route',
    validWhere: ['ProfScreen', '/chiedi', 'chiedi_messages', "sessions.mode='chiedi'", 'resume logic'],
  },
  {
    key: 'allena',
    currentMeaning: 'Practice implementation/session key, not a top-level drawer section',
    validWhere: ['PracticeScreen', '/allena', "sessions.mode='allena'", 'practice post-mortem routes'],
  },
  {
    key: 'studia',
    currentMeaning: 'Legacy lesson namespace, not a top-level drawer section',
    validWhere: ['/studia redirect', '/studia/lezione/... deep links', 'Fast/Deep lesson internals'],
  },
  {
    key: 'simula',
    currentMeaning: 'Implementation shorthand for the current Simula Esame section',
    validWhere: ['/simula', 'SimulaScreen', 'simulator session modes', 'simula post-mortem routes'],
  },
] as const;
